/**********************************************************
 * 
 *  GoogleAnalytics is a wrapper for the react-ga module
 *  It includes some custom logging functions
 * 
 **********************************************************/
import ReactGA from 'react-ga';

console.log('Google Analytics Initialized');
ReactGA.initialize('UA-105573738-1');

/**********************************************************
 *  Functions
 **********************************************************/

// Log new page to GA
function newPage(newPage) {

    ReactGA.pageview(newPage);

}


// Given a category, action and possibly a label, log it to GA
function newAction(category, action, label) {

    if(label !== undefined) {
        ReactGA.event({
            category : category,
            action : action,
            label : label
        });
    }
    else {
        ReactGA.event({
            category : category,
            action : action
        });
    }

}


const GoogleAnalytics = { newPage, newAction };
export default GoogleAnalytics;






// WEBPACK FOOTER //
// ./src/Utils/GoogleAnalytics.js